import { Box } from '@wix/design-system';
import React from 'react';
export const TldOfferCarouselSlide = _ref => {
  let children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    width: "206px",
    height: "100%",
    direction: "vertical"
  }, children);
};
//# sourceMappingURL=TldOfferCarouselSlide.js.map